/*
Safari < 15.4 lacks Array.prototype.at, and @ariakit/react-components >= 0.4.1
calls it (getFrameChain(...).at(-1) in dialog/utils/use-hide-on-interact-outside.js).
*/

export function arrayAt<T>(arr: ArrayLike<T>, index: number): T | undefined {
  const len = Math.min(Math.max(Math.trunc(Number(arr.length)) || 0, 0), Number.MAX_SAFE_INTEGER)
  const relative = Math.trunc(index) || 0
  const k = relative < 0 ? len + relative : relative
  return k < 0 || k >= len ? undefined : arr[k]
}

if (typeof (Array.prototype as {at?: unknown}).at !== 'function') {
  Object.defineProperty(Array.prototype, 'at', {
    value: function at<T>(this: ArrayLike<T>, index: number) {
      return arrayAt(this, index)
    },
    writable: true,
    configurable: true,
    enumerable: false
  })
}
